import {
  GroupRepliesResponse,
  OwnerType,
  QuickReplyGroupItem,
  QuickReplyItem,
} from '@/interfaces/quick-reply';
import request from '@/utils/request';

export const getGroupReplies = () => {
  return request<GroupRepliesResponse>({ url: '/v1/quick-reply/group-replies', method: 'GET' });
};

export const createGroup = (ownerType: OwnerType, title: string) => {
  return request<QuickReplyGroupItem>({
    url: '/v1/quick-reply/group/create',
    method: 'POST',
    data: { ownerType, title },
  });
};

export const updateGroup = (id: number, title: string) => {
  return request({
    url: '/v1/quick-reply/group/update',
    method: 'PUT',
    data: { id, title },
  });
};

export const deleteGroup = (id: number) => {
  return request({ url: '/v1/quick-reply/group/delete', method: 'DELETE', data: { id } });
};

export const moveGroup = (groupId: number, targetPosition: number) => {
  return request({
    url: '/v1/quick-reply/group/move',
    method: 'POST',
    data: { groupId, targetPosition },
  });
};

export const createReply = (data: Partial<QuickReplyItem>) => {
  return request({
    url: '/v1/quick-reply/reply/create',
    method: 'POST',
    data,
  });
};
export const moveReply = (id: number, groupId: number, targetPosition: number) => {
  return request({
    url: '/v1/quick-reply/reply/move',
    method: 'POST',
    data: { id, groupId, targetPosition },
  });
};

export const updateReply = (data: Partial<QuickReplyItem>) => {
  return request({
    url: '/v1/quick-reply/reply/update',
    method: 'PUT',
    data,
  });
};

export const deleteReply = (id: number) => {
  return request({
    url: '/v1/quick-reply/reply/delete',
    method: 'DELETE',
    data: { id },
  });
};

export const importQuickReply = (ownerType: OwnerType, file: File) => {
  return request({
    url: '/v1/quick-reply/import',
    method: 'POST',
    data: { ownerType, file },
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
